import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=41a6b1de&scoped=true"
import script from "./ClientDetail.vue?vue&type=script&lang=js"
export * from "./ClientDetail.vue?vue&type=script&lang=js"
import style0 from "./ClientDetail.vue?vue&type=style&index=0&id=41a6b1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6b1de",
  null
  
)

export default component.exports